<template>
  <div class="w-full h-screen flex items-center justify-center px-4">
    <div
      class="bg-[#3176FF0F] rounded-[3.125rem] w-full md:max-w-[56.25rem] flex flex-col items-center pb-[3.125rem] pt-[11.75rem] px-8"
    >
      <div class="text-txprimary text-2xl md:text-2.5xl font-bold mb-6 text-center relative w-full">
        Упс, страница не найдена :(
        <div class="absolute md:w-[25rem] w-full md:translate-x-1/2 -translate-y-[27rem]">
          <NuxtImg src="/assets/svg/404.svg" alt="error" class="w-full z-10" />
        </div>
      </div>
      <div class="text-txprimary text-base font-normal mb-8">Но вы можете перейти на главную!</div>
      <div class="w-full flex justify-center">
        <!-- <NuxtLink :to="link" class=""> -->
        <UINewButtonsButton
          buttonText="Открыть главную"
          button-class="!py-5 !max-h-fit !h-auto md:!px-[5.40625rem] !w-full md:!w-fit"
          button-text-class=""
          @click="navigateTo(link)"
        />
        <!-- </NuxtLink> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  setResponseStatus(404);

  useHead({
    title: "Страница не найдена - 404",
  });
  const props = defineProps(["error"]);

  const link = computed(() => {
    if (props.error.message.includes("publisher")) {
      return "/publisher";
    }
    return "/";
  });
</script>

<style lang="scss" scoped></style>
